import { SET_IS_OPEN_FORM_MODAL } from '../actionTypes';
import { supplierIntegrationsActions } from '../reducer';

export default (isOpen) =>
    supplierIntegrationsActions[SET_IS_OPEN_FORM_MODAL](isOpen);
